var disposed = false
var normalizeComponent = require("!../../../../45/node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../../45/node_modules/vue-loader/lib/selector?type=script&index=0!./globalPath.vue"
import __vue_script__ from "!!babel-loader!../../../../45/node_modules/vue-loader/lib/selector?type=script&index=0!./globalPath.vue"
/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/assets/script/globalPath.vue"

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-26ff0d0e", Component.options)
  } else {
    hotAPI.reload("data-v-26ff0d0e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/assets/script/globalPath.vue
// module id = null
// module chunks = 